import { createSlice } from "@reduxjs/toolkit";
import { BuscarPessoaModel } from "../../../models/pessoa/chamadas/buscarPessoaModel";
import { CategoriaPessoaModel } from "../../../models/pessoa/categoriaPessoaModel";
import { PessoaModel } from "../../../models/pessoa/pessoaModel";
import { buscarPessoa, listarCategoriaPessoa } from "../../../services/pessoaService";
import { resetAll } from "../../actions/actions";

export interface PessoaState {
  //buscar pessoa
  loading: boolean;
  busca: BuscarPessoaModel;
  list: PessoaModel[];
  entity: PessoaModel;
  //buscar categoria pessoa
  loadingCategoria: boolean;
  listCategoria: CategoriaPessoaModel[];
  //internal
  page: string;
  modalDeletar: boolean;
}

const initialState: PessoaState = {
  //buscar pessoa
  loading: false,
  busca: {
    idCategoriaPessoa: null,
    exibeContaPagar: null,
    exibeContaReceber: null,
    pesquisar: null,
    ativo: null,
  } as BuscarPessoaModel,
  list: [],
  entity: {} as PessoaModel,
  //buscar categoria
  loadingCategoria: false,
  listCategoria: [],
  //internal
  page: "geral",
  modalDeletar: false,
};

export const pessoaSlice = createSlice({
  name: "pessoa",
  initialState,
  reducers: {
    //buscar pessoa
    setBuscaPessoa: (state, action) => {
      state.busca = action.payload;
    },
    setEntityPessoa: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setPagePessoa: (state, action) => {
      state.page = action.payload;
    },
    setModalDeletarPessoa: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar pessoa
    builder.addCase(buscarPessoa.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarPessoa.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarPessoa.rejected, (state, action) => {
      state.loading = false;
    });

    //buscar categoria
    builder.addCase(listarCategoriaPessoa.pending, (state) => {
      state.loadingCategoria = true;
    });
    builder.addCase(listarCategoriaPessoa.fulfilled, (state, action) => {
      state.listCategoria = action.payload;
      state.loadingCategoria = false;
    });
    builder.addCase(listarCategoriaPessoa.rejected, (state, action) => {
      state.loadingCategoria = false;
    });
  },
});

export const {
  //buscar pessoa
  setBuscaPessoa,
  setEntityPessoa,
  //internal
  setPagePessoa,
  setModalDeletarPessoa,
} = pessoaSlice.actions;

export default pessoaSlice.reducer;
